var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-list-ul" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("configuration")) + "\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        { staticClass: "shadow-1 q-mt-md", attrs: { color: "secondary" } },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "login",
              label: "login"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "register", label: "register" },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "self_register",
              label: "self_register"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "user_profile",
              label: "user_profile"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "layout", label: "layout" },
            slot: "title"
          }),
          _vm._l(_vm.clients, function(client, index) {
            return _vm.disablegetClientName(client.id)
              ? _c("q-tab", {
                  key: "t" + index,
                  attrs: {
                    slot: "title",
                    name: "c" + client.id,
                    label: _vm.getClientName(client.id)
                  },
                  slot: "title"
                })
              : _vm._e()
          }),
          _c("q-tab-pane", { attrs: { name: "login" } }, [
            _c(
              "div",
              { staticClass: "row reverse gutter-md" },
              _vm._l(_vm.login, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12" },
                  [
                    item.type === "boolean" || item.type === "text"
                      ? _c(
                          "q-field",
                          { attrs: { helper: item.helper } },
                          [
                            item.type === "text"
                              ? _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "boolean"
                              ? _c("q-select", {
                                  attrs: {
                                    options: [
                                      { value: true, label: "true" },
                                      { value: false, label: "false" }
                                    ],
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "color"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "q-caption text-faded" },
                              [_vm._v(_vm._s(_vm.$t("colors")))]
                            ),
                            _vm._l(item.value, function(color, index) {
                              return _c(
                                "div",
                                { key: "c" + index, staticClass: "col-12" },
                                [
                                  _c(
                                    "q-field",
                                    { attrs: { helper: color.helper } },
                                    [
                                      _c("q-color", {
                                        attrs: { "float-label": color.label },
                                        model: {
                                          value: color.value,
                                          callback: function($$v) {
                                            _vm.$set(color, "value", $$v)
                                          },
                                          expression: "color.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    item.type === "background_color"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "q-field",
                                { attrs: { helper: item.helper } },
                                [
                                  _c("q-color", {
                                    attrs: { "float-label": item.label },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    item.type === "font_color"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "q-field",
                                { attrs: { helper: item.helper } },
                                [
                                  _c("q-color", {
                                    attrs: { "float-label": item.label },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    item.type === "oauth2"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "q-caption text-faded" },
                              [_vm._v(_vm._s(_vm.$t("oauth2")))]
                            ),
                            _vm._l(item.value, function(oauth2, index) {
                              return _c(
                                "div",
                                { key: "c" + index, staticClass: "col-12" },
                                [
                                  _c(
                                    "q-field",
                                    { attrs: { helper: oauth2.helper } },
                                    [
                                      _c("q-input", {
                                        attrs: { "float-label": oauth2.label },
                                        model: {
                                          value: oauth2.value,
                                          callback: function($$v) {
                                            _vm.$set(oauth2, "value", $$v)
                                          },
                                          expression: "oauth2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    item.type === "upload"
                      ? _c("div", { staticClass: "row" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s() +
                              "\n                        "
                          ),
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploader", {
                                attrs: {
                                  content_type: "images",
                                  multiple: false,
                                  cropper: false,
                                  item: item,
                                  custom_directory: true,
                                  filename: item.label,
                                  slug: "login",
                                  aspect_ratio: _vm.getAspectNumber(item),
                                  aspect_ratio_string: _vm.getAspectString(
                                    item
                                  ),
                                  no_expiration: true
                                },
                                on: { fileUploaded: _vm.imageUploaded }
                              }),
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.helper))]
                              ),
                              item.value
                                ? _c(
                                    "p",
                                    { staticClass: "q-mt-md file-url" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.value,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$truncateLink(item.value)
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("q-tab-pane", { attrs: { name: "register" } }, [
            _c(
              "div",
              { staticClass: "row reverse gutter-sm" },
              _vm._l(_vm.register, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12" },
                  [
                    item.type === "boolean" || item.type === "text"
                      ? _c(
                          "q-field",
                          { attrs: { helper: item.helper } },
                          [
                            item.type === "text"
                              ? _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "boolean"
                              ? _c("q-select", {
                                  attrs: {
                                    options: [
                                      { value: true, label: "true" },
                                      { value: false, label: "false" }
                                    ],
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "field"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "q-caption text-faded" },
                              [_vm._v(_vm._s(_vm.$t("fields")))]
                            ),
                            _vm._l(item.value, function(field, index) {
                              return _c(
                                "div",
                                { key: "c" + index, staticClass: "col-12" },
                                [
                                  _c(
                                    "q-field",
                                    { attrs: { helper: field.helper } },
                                    [
                                      _c("q-select", {
                                        attrs: {
                                          options: [
                                            { value: true, label: "true" },
                                            { value: false, label: "false" }
                                          ],
                                          "float-label": field.label
                                        },
                                        model: {
                                          value: field.value,
                                          callback: function($$v) {
                                            _vm.$set(field, "value", $$v)
                                          },
                                          expression: "field.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    item.type === "upload"
                      ? _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploader", {
                                attrs: {
                                  content_type: "images",
                                  multiple: false,
                                  cropper: false,
                                  item: item,
                                  custom_directory: true,
                                  filename: item.label,
                                  slug: "login",
                                  aspect_ratio: _vm.getAspectNumber(item),
                                  aspect_ratio_string: _vm.getAspectString(
                                    item
                                  ),
                                  no_expiration: true
                                },
                                on: { fileUploaded: _vm.imageUploaded }
                              }),
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.helper))]
                              ),
                              item.value
                                ? _c(
                                    "p",
                                    { staticClass: "q-mt-md file-url" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.value,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$truncateLink(item.value)
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("q-tab-pane", { attrs: { name: "self_register" } }, [
            _c(
              "div",
              { staticClass: "row reverse gutter-sm" },
              _vm._l(_vm.self_register, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12" },
                  [
                    item.type === "boolean" || item.type === "text"
                      ? _c(
                          "q-field",
                          { attrs: { helper: item.helper } },
                          [
                            item.type === "text"
                              ? _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "boolean"
                              ? _c("q-select", {
                                  attrs: {
                                    options: [
                                      { value: true, label: "true" },
                                      { value: false, label: "false" }
                                    ],
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "field"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "q-caption text-faded" },
                              [_vm._v(_vm._s(_vm.$t("fields")))]
                            ),
                            _vm._l(item.value, function(field, index) {
                              return _c(
                                "div",
                                { key: "c" + index, staticClass: "col-12" },
                                [
                                  _c(
                                    "q-field",
                                    { attrs: { helper: field.helper } },
                                    [
                                      _c("q-select", {
                                        attrs: {
                                          options: [
                                            { value: true, label: "true" },
                                            { value: false, label: "false" }
                                          ],
                                          "float-label": field.label
                                        },
                                        model: {
                                          value: field.value,
                                          callback: function($$v) {
                                            _vm.$set(field, "value", $$v)
                                          },
                                          expression: "field.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    item.type === "upload"
                      ? _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploader", {
                                attrs: {
                                  content_type: "images",
                                  multiple: false,
                                  cropper: false,
                                  item: item,
                                  custom_directory: true,
                                  filename: item.label,
                                  slug: "login",
                                  aspect_ratio: _vm.getAspectNumber(item),
                                  aspect_ratio_string: _vm.getAspectString(
                                    item
                                  ),
                                  no_expiration: true
                                },
                                on: { fileUploaded: _vm.imageUploaded }
                              }),
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.helper))]
                              ),
                              item.value
                                ? _c(
                                    "p",
                                    { staticClass: "q-mt-md file-url" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.value,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$truncateLink(item.value)
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("q-tab-pane", { attrs: { name: "user_profile" } }, [
            _c(
              "div",
              { staticClass: "row reverse gutter-sm" },
              _vm._l(_vm.user_profile, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12" },
                  [
                    item.type === "boolean" || item.type === "text"
                      ? _c(
                          "q-field",
                          { attrs: { helper: item.helper } },
                          [
                            item.type === "text"
                              ? _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "boolean"
                              ? _c("q-select", {
                                  attrs: {
                                    options: [
                                      { value: true, label: "true" },
                                      { value: false, label: "false" }
                                    ],
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "field"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "span",
                              { staticClass: "q-caption text-faded" },
                              [_vm._v(_vm._s(_vm.$t("fields")))]
                            ),
                            _vm._l(item.value, function(field, index) {
                              return _c(
                                "div",
                                { key: "c" + index, staticClass: "col-12" },
                                [
                                  _c(
                                    "q-field",
                                    { attrs: { helper: field.helper } },
                                    [
                                      _c("q-select", {
                                        attrs: {
                                          options: [
                                            { value: true, label: "true" },
                                            { value: false, label: "false" }
                                          ],
                                          "float-label": field.label
                                        },
                                        model: {
                                          value: field.value,
                                          callback: function($$v) {
                                            _vm.$set(field, "value", $$v)
                                          },
                                          expression: "field.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    item.type === "upload"
                      ? _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploader", {
                                attrs: {
                                  content_type: "images",
                                  multiple: false,
                                  cropper: false,
                                  item: item,
                                  custom_directory: true,
                                  filename: item.label,
                                  slug: "login",
                                  aspect_ratio: _vm.getAspectNumber(item),
                                  aspect_ratio_string: _vm.getAspectString(
                                    item
                                  ),
                                  no_expiration: true
                                },
                                on: { fileUploaded: _vm.imageUploaded }
                              }),
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.helper))]
                              ),
                              item.value
                                ? _c(
                                    "p",
                                    { staticClass: "q-mt-md file-url" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.value,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$truncateLink(item.value)
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("q-tab-pane", { attrs: { name: "layout" } }, [
            _c(
              "div",
              { staticClass: "row reverse gutter-sm" },
              _vm._l(_vm.layout, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12" },
                  [
                    item.type === "boolean" ||
                    item.type === "text" ||
                    item.type === "color"
                      ? _c(
                          "q-field",
                          { attrs: { helper: item.helper } },
                          [
                            item.type === "text"
                              ? _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "color"
                              ? _c("q-color", {
                                  attrs: { "float-label": item.label },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e(),
                            item.type === "boolean"
                              ? _c("q-select", {
                                  attrs: {
                                    options: [
                                      { value: true, label: "true" },
                                      { value: false, label: "false" }
                                    ],
                                    "float-label": item.label
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    item.type === "upload"
                      ? _c("div", { staticClass: "row" }, [
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(item.label))
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("uploader", {
                                attrs: {
                                  content_type: "images",
                                  multiple: false,
                                  cropper: false,
                                  item: item,
                                  custom_directory: true,
                                  filename: item.label,
                                  slug: "login",
                                  aspect_ratio: _vm.getAspectNumber(item),
                                  aspect_ratio_string: _vm.getAspectString(
                                    item
                                  ),
                                  no_expiration: true
                                },
                                on: { fileUploaded: _vm.imageUploaded }
                              }),
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.helper))]
                              ),
                              item.value
                                ? _c(
                                    "p",
                                    { staticClass: "q-mt-md file-url" },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check",
                                          color: "positive"
                                        }
                                      }),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: item.value,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$truncateLink(item.value)
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm._l(_vm.clients, function(client, index) {
            return _c(
              "q-tab-pane",
              { key: "p" + index, attrs: { name: "c" + client.id } },
              [
                _c(
                  "div",
                  { staticClass: "row reverse gutter-md" },
                  _vm._l(client.field, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12" },
                      [
                        item.type === "boolean" || item.type === "text"
                          ? _c(
                              "q-field",
                              { attrs: { helper: item.helper } },
                              [
                                item.type === "text"
                                  ? _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        "float-label": item.label,
                                        disable: item.disabled
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value"
                                      }
                                    })
                                  : _vm._e(),
                                item.type === "boolean"
                                  ? _c("q-select", {
                                      attrs: {
                                        options: [
                                          { value: true, label: "true" },
                                          { value: false, label: "false" }
                                        ],
                                        "float-label": item.label
                                      },
                                      model: {
                                        value: item.value,
                                        callback: function($$v) {
                                          _vm.$set(item, "value", $$v)
                                        },
                                        expression: "item.value"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        item.type === "color"
                          ? _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "q-caption text-faded" },
                                  [_vm._v(_vm._s(_vm.$t("colors")))]
                                ),
                                _vm._l(item.value, function(color, index) {
                                  return _c(
                                    "div",
                                    { key: "c" + index, staticClass: "col-12" },
                                    [
                                      _c(
                                        "q-field",
                                        { attrs: { helper: color.helper } },
                                        [
                                          _c("q-color", {
                                            attrs: {
                                              "float-label": color.label
                                            },
                                            model: {
                                              value: color.value,
                                              callback: function($$v) {
                                                _vm.$set(color, "value", $$v)
                                              },
                                              expression: "color.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        item.type === "upload"
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(item.label))]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("uploader", {
                                    attrs: {
                                      content_type: "images",
                                      multiple: false,
                                      cropper: false,
                                      item: item,
                                      custom_directory: true,
                                      filename: item.label,
                                      slug: "clients",
                                      client_id: client.id,
                                      aspect_ratio_string: _vm.getAspectString(
                                        item
                                      ),
                                      no_expiration: true
                                    },
                                    on: { fileUploaded: _vm.imageUploaded }
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "q-caption text-faded" },
                                    [_vm._v(_vm._s(item.helper))]
                                  ),
                                  item.value
                                    ? _c(
                                        "p",
                                        { staticClass: "q-mt-md file-url" },
                                        [
                                          _c("q-icon", {
                                            attrs: {
                                              name: "fal fa-check",
                                              color: "positive"
                                            }
                                          }),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: item.value,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$truncateLink(
                                                      item.value
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          })
        ],
        2
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_overview" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveConfig()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: { "content-css": { minWidth: "50vw" } },
          model: {
            value: _vm.show_new_configuration_selection,
            callback: function($$v) {
              _vm.show_new_configuration_selection = $$v
            },
            expression: "show_new_configuration_selection"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideNewConfiguration()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("add_configuration")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": _vm.$t("type"),
                          options: _vm.new_configuration_types
                        },
                        model: {
                          value: _vm.new_configuration_type,
                          callback: function($$v) {
                            _vm.new_configuration_type = $$v
                          },
                          expression: "new_configuration_type"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: { "float-label": _vm.$t("slug") },
                        model: {
                          value: _vm.new_configuration_slug,
                          callback: function($$v) {
                            _vm.new_configuration_slug = $$v
                          },
                          expression: "new_configuration_slug"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              return _vm.hideNewConfiguration()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("add"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addNewConfiguration()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }